var e={lightTheme:{MuiAvatar:{styleOverrides:{root:{width:32,height:32,fontWeight:600,fontSize:12,lineHeight:"16px"}}}}};export{e as default};